var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success",staticStyle:{"white-space":"nowrap"},attrs:{"type":"button","data-toggle":"modal","data-target":".bd-add-job-modal-lg"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }